import * as React from 'react'
import cx from 'classnames'
import Styles from './Checkbox.module.scss'
import { Check } from 'blaze-ui/icons/16'

interface CheckboxProps {
  className?: string
  checked: boolean
  id: string
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void
  disable?: boolean
  visible?: boolean
}

export const Checkbox = ({ className, id, onClick, disable = false, checked, visible = false }: CheckboxProps) => {
  return (
    <span className={cx(Styles.checkboxContainer, className, { [Styles.visible]: visible })} onClick={onClick}>
      <input type="checkbox" id={id} readOnly disabled={disable} checked={checked} data-testid={`checkbox-${id}`} />
      <div
        className={cx(Styles.checkbox, {
          [Styles.selected]: checked,
        })}
      >
        {checked && <Check />}
      </div>
    </span>
  )
}
